import { createAction, props } from '@ngrx/store';
import { IGrupo, ICreateGrupo, IDeleteGrupoResponse, IUpdateGrupo, IUpdateGrupoResponse, IIntegrante} from '../../interfaces/grupos.interface';

export const GetGrupos = createAction(
    '[Grupos] Get Grupos',
  );

export const GetGruposSuccess = createAction(
    '[Grupos] Get Grupos Success',
    props<{grupos: IGrupo[]}>()
  );

export const CreateGrupo = createAction(
    '[Grupos] Create Grupo',
    props<{grupo: ICreateGrupo}>()
  );

export const CreateGrupoSuccess = createAction(
    '[Grupos] Create Grupo Success',
    props<{grupo: IGrupo}>()
  );

export const DeleteGrupo = createAction(
    '[Grupos] Delete Grupo',
    props<{id: string}>()
  );

export const DeleteGrupoSuccess = createAction(
    '[Grupos] Delete Grupo Success',
    props<{grupo: IDeleteGrupoResponse}>()
  );

export const UpdateGrupo = createAction(
    '[Grupos] Update Grupo',
    props<{id: string, grupo: IUpdateGrupo}>()
  );

export const UpdateGrupoSuccess = createAction(
    '[Grupos] Update Grupo Success',
    props<{grupo: IUpdateGrupoResponse}>()
  );

export const AddIntegranteGrupo = createAction(
    '[Grupos] Add Integrante Grupo',
    props<{id: string, integrante: any}>()
  );

export const AddIntegranteGrupoSuccess = createAction(
    '[Grupos] Add Integrante Grupo Success',
    props<{integrante: IGrupo}>()
  );

export const DeleteIntegranteGrupo = createAction(
    '[Grupos] Delete Integrante Grupo',
    props<{id: string, integrante: any}>()
  );

export const DeleteIntegranteGrupoSuccess = createAction(
    '[Grupos] Delete Integrante Grupo Success',
    props<{integrante: IGrupo}>()
  );

  export const GetSesiones = createAction(
    '[Grupos] Get Sesiones',
    props<{ id: string }>()
  );

  export const GetSesionesSuccess = createAction(
    '[Grupos] Get Sesiones Success',
    props<{ sesiones: any }>()
  );

  export const GetAsistencias = createAction(
    '[Grupos] Get Asistencia',
    props<{ id: string }>()
  );

  export const GetAsistenciasSuccess = createAction(
    '[Grupos] Get Asistencias Success',
    props<{ asistencias: any }>()
  );

  export const CreateAsistencias = createAction(
    '[Grupos] Create Asistencia',
    props<{ asistencias: any }>()
  );

  export const CreateAsistenciasSuccess = createAction(
    '[Grupos] Create Asistencia Success',
    props<{ asistencias: any }>()
  );
